<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="frontmatter" id="ser">
<p class="sert" style="text-align:center;"><span aria-label="ii" class="page" epub:type="pagebreak" id="pii" role="doc-pagebreak"></span><img alt="" height="75" src="images/logo-Opera-Lab.jpg" width="111"/></p>
<p class="sert" style="text-align:center;">Opera Lab: Explorations in History, Technology, and Performance</p>
<p class="sered" style="text-align:center;">A series edited by David J. Levin &amp; Mary Ann Smart</p>
<p class="serah" style="text-align:center;">ADVISORY BOARD</p>
<p class="seraft" style="text-align:center;">Carolyn Abbate</p>
<p class="ser" style="text-align:center;">Gundula Kreuzer</p>
<p class="ser" style="text-align:center;">Emanuele Senici</p>
<p class="ser" style="text-align:center;">Benjamin Walton</p>
<p class="ser" style="text-align:center;">Emily Wilbourne</p>
<p class="serah" style="text-align:center;">ALSO PUBLISHED IN THE SERIES</p>
<p class="seraft" style="text-align:center;"><i>Music in the Present Tense: Rossini’s Italian Operas in Their Time</i></p>
<p class="serau" style="text-align:center;">Emanuele Senici</p>
<p class="ser" style="text-align:center;"><i>Singing Sappho: Improvisation and Authority in Nineteenth-Century Italian Opera</i></p>
<p class="serau" style="text-align:center;">Melina Esse</p>
<p class="ser" style="text-align:center;"><i>Networking Operatic Italy</i></p>
<p class="serau" style="text-align:center;">Francesca Vella</p>
<p class="ser" style="text-align:center;"><i>“Don Giovanni” Captured: Performance, Media, Myth</i></p>
<p class="serau" style="text-align:center;">Richard Will</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-bentley-0003.vue?65082172